var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpilledProducedWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1800_27239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1800_27239)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1800_27239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4493 46.8558C42.3117 46.5027 43.1473 46.1604 43.9916 45.8146C43.7001 45.4587 43.4035 45.1491 43.115 44.8354C42.881 44.5807 42.6439 44.3243 42.397 44.0798C42.131 43.817 41.9016 43.5138 41.6404 43.2455C41.2219 42.8153 40.8209 42.3682 40.4128 41.9278C39.813 41.2802 39.2105 40.6351 38.6083 39.99C38.2198 39.5739 37.8268 39.1613 37.4426 38.7416C37.1088 38.3772 36.7696 38.017 36.4378 37.6505C36.29 37.4873 36.1651 37.2956 35.9787 37.1693C35.8974 37.1144 35.8668 37.036 35.8907 36.9178C35.9209 36.7669 35.9888 36.6353 36.0348 36.4936C36.1872 36.0254 36.3552 35.5621 36.5261 35.1024C36.6635 34.7334 36.8059 34.3623 36.9745 34.0039C37.1206 33.6933 37.2542 33.3753 37.405 33.0668C37.5558 32.7587 37.7079 32.4512 37.8671 32.1477C38.0186 31.8592 38.1647 31.5659 38.341 31.2943C38.4891 31.066 38.6188 30.8262 38.7685 30.6C38.9489 30.3277 39.1252 30.0516 39.3133 29.7853C39.6679 29.283 40.0317 28.7878 40.4024 28.2981C41.018 27.4852 41.676 26.7135 42.3473 25.9533C42.5942 25.674 42.8632 25.4109 43.111 25.1348C43.4348 24.7739 43.7636 24.4169 44.1028 24.0746C44.7879 23.3827 45.4542 22.6694 46.1958 22C46.2314 22.2916 46.2025 22.5635 46.1904 22.8333C46.1638 23.4267 46.1551 24.0208 46.1806 24.6125C46.2078 25.246 46.3197 25.8707 46.4312 26.4954C46.5336 27.0705 46.7025 27.6224 46.8883 28.1676C47.0192 28.5524 47.1818 28.9274 47.3521 29.2992C47.5707 29.7758 47.8088 30.2384 48.0745 30.684C48.3143 31.0861 48.5719 31.4772 48.8459 31.8575C49.0917 32.1987 49.3366 32.5431 49.573 32.8927C49.8346 33.2796 50.1329 33.6409 50.379 34.0376C50.7465 34.6293 51.1273 35.2121 51.4541 35.8316C51.7127 36.3216 51.9501 36.8225 52.1463 37.3399C52.3504 37.8784 52.5053 38.4367 52.6423 39.0019C52.8811 39.9879 52.9765 40.9893 52.9993 41.9992C53.0141 42.6496 52.9247 43.294 52.8485 43.9405C52.7907 44.4298 52.6359 44.8843 52.4999 45.3412C52.3928 45.7014 52.2262 46.0528 52.0475 46.3929C51.8974 46.6793 51.7385 46.9607 51.5649 47.2276C51.3412 47.572 51.0833 47.8967 50.7894 48.1816C50.551 48.4127 50.3129 48.6515 50.0435 48.8383C49.4534 49.2481 48.8113 49.5404 48.1117 49.6909C47.2201 49.8827 46.3476 49.8211 45.474 49.5604C44.9904 49.4162 44.5444 49.2003 44.1051 48.9561C43.6316 48.6934 43.2034 48.3627 42.7758 48.0258C42.3171 47.6642 41.9063 47.248 41.4486 46.8565L41.4493 46.8558ZM46.859 48.1992C47.2869 48.2576 47.7487 48.0824 48.1903 47.8942C48.7428 47.6585 49.256 47.3289 49.7389 46.9571C49.8726 46.8541 49.9962 46.731 50.1043 46.5987C50.245 46.4263 50.3935 46.2614 50.5251 46.0785C50.7025 45.8315 50.8657 45.5716 50.9789 45.2955C51.1196 44.9521 51.2741 44.612 51.3486 44.2342C51.4312 43.817 51.528 43.4037 51.5736 42.9799C51.6801 41.9922 51.5118 41.0266 51.2902 40.0797C51.1515 39.4877 50.9533 38.9013 50.6669 38.3596C50.6172 38.2661 50.5849 38.0919 50.4842 38.1166C50.3841 38.1408 50.4244 38.3114 50.4287 38.4166C50.4731 39.4603 50.336 40.4853 50.0832 41.4874C49.9277 42.1037 49.7114 42.7076 49.4407 43.2827C49.2835 43.6169 49.1166 43.9461 48.9373 44.2694C48.6209 44.8396 48.2531 45.3683 47.8642 45.8829C47.6026 46.229 47.3074 46.5435 47.0182 46.8636C46.8812 47.0152 46.7338 47.1573 46.5833 47.2941C46.3536 47.5034 46.1152 47.7018 45.8861 47.9118C45.8549 47.9406 45.7894 47.9677 45.8085 48.0342C45.8283 48.1017 45.8898 48.1077 45.9459 48.1193C46.2243 48.1774 46.5051 48.2051 46.8594 48.1992H46.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 47.543C33.1538 47.0931 33.2334 46.6791 33.3597 46.277C33.5662 45.6203 33.7392 44.9516 33.934 44.2907C34.0794 43.7979 34.2195 43.3033 34.3595 42.8091C34.5583 42.107 34.779 41.4109 34.9556 40.7024C35.056 40.2986 35.2052 39.9121 35.3143 39.4893C37.1457 41.3863 38.9723 43.2787 40.8259 45.1985C40.6069 45.2745 40.4094 45.3716 40.2022 45.4082C39.8281 45.4743 39.4855 45.641 39.1218 45.7367C39.0264 45.7617 39.0674 45.8299 39.0932 45.8746C39.3804 46.3737 39.7061 46.8447 40.0403 47.3105C40.1736 47.4962 40.3399 47.6499 40.4598 47.8497C40.5498 47.9995 40.6878 48.1216 40.806 48.2535C41.0811 48.5602 41.3578 48.8712 41.6702 49.1332C41.9926 49.4037 42.3214 49.669 42.6911 49.8789C43.0334 50.0731 43.3816 50.2486 43.7477 50.3746C44.3966 50.5972 45.0558 50.7854 45.7463 50.7984C46.0482 50.8041 46.3512 50.7882 46.6528 50.8019C47.3258 50.8329 47.977 50.6862 48.6295 50.5497C49.007 50.4709 49.3943 50.4519 49.7691 50.3443C49.5249 50.4776 49.2616 50.5554 49.0127 50.6714C48.6836 50.8252 48.3427 50.9535 48.0015 51.0767C47.3117 51.3257 46.6249 51.6018 45.9062 51.7327C44.4963 51.9895 43.0723 52.0682 41.6436 51.9367C41.1641 51.8924 40.6855 51.8217 40.2103 51.7397C40.0286 51.7084 39.8583 51.6089 39.681 51.5452C39.245 51.3887 38.8219 51.2012 38.4259 50.9546C38.0578 50.7256 37.7032 50.4762 37.3552 50.2117C36.9519 49.905 36.5892 49.5536 36.2466 49.186C36.0048 48.9264 35.7771 48.6411 35.5746 48.3355C35.4224 48.1061 35.279 47.8638 35.1021 47.6531C34.9892 47.5187 34.9234 47.3569 34.826 47.2141C34.7101 47.0442 34.5943 47.0174 34.433 47.0892C33.9877 47.2872 33.4974 47.3221 33.0007 47.5423L33 47.543Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1800_27239",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27239",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1800_27239",
    x: 27,
    y: 20,
    width: 32,
    height: 41.999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27239",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1800_27239",
    x1: 43,
    y1: 12,
    x2: 43,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpilledProducedWater);
export default __webpack_public_path__ + "static/media/SpilledProducedWater.36802ce116f3d1e133adcf91e3bba194.svg";
export { ForwardRef as ReactComponent };